module.exports = __webpack_public_path__ + "static/media/Restart_HBT.22ec5dae.svg";